// removed by extract-text-webpack-plugin
module.exports = {"selector_wrapper":"selector_wrapper__37DQi"};


//////////////////
// WEBPACK FOOTER
// ./components/selector/style.scss
// module id = Jxom
// module chunks = 13